import { assignJob, getFreePopulation, MAX_WEAVERS } from '../map/settlement';
import type { ModalActionHandler } from './modalActionTypes';
import { getSettlement } from './settlementActionUtils';

export const hireWeaverAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement || settlement.buildings.weaver.qty <= 0) return false;
    const freePop = getFreePopulation(settlement);
    const cap = MAX_WEAVERS * settlement.buildings.weaver.qty;
    if (settlement.jobs.weavers >= cap || freePop <= 0) return false;
    if (!assignJob(settlement, 'weavers')) return false;
    settlement.production.weaver.progress.push(0);
    return true;
};
